import { APIEndPoints } from "@api/endPoints";
import { APICaller } from "@api/request";
import { HTTPMethods } from "@enums/HttpMethods";
import { RequestContentType } from "@enums/RequestContentType";

// export const getImage = async (id: string, APICaller: APICaller) => {
//     const { jsonResponse } = await APICaller.validateAndCallAPI(
//         APIEndPoints.GetImage.format(id),
//         HTTPMethods.GET,
//         null,
//         RequestContentType.JSON,
//         null,
//         true
//     );

//     if (!jsonResponse.success) {
//         throw jsonResponse;
//     }
//     return jsonResponse;
// };
export const getImage = async (id: string, APICaller: APICaller) => {
    const url = APIEndPoints.GetImage.replace("{0}", id.toString());
    const { jsonResponse } = await APICaller.validateAndCallAPI(url, HTTPMethods.GET);

    if (!jsonResponse.success) {
        throw jsonResponse;
    }

    return jsonResponse;
};

